import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  role: Yup.string().required('common::validation_messages.required'),
  send_invite_to: Yup.string()
    .test(
      'email_or_phone',
      'services::forms.account_access_create.yd.fields.send_invite_to.errors.invalid',
      (value) => validateEmail(value) || validatePhone(parseInt(value ?? '0')),
    )
    .required('common::validation_messages.required'),
})

export const validateEmail = (email) => Yup.string().email().isValidSync(email)

export const validatePhone = (phone) =>
  Yup.number()
    .integer()
    .positive()
    .test((phone) => phone && phone.toString().length >= 8 && phone.toString().length <= 14)
    .isValidSync(phone)
